module.exports = __webpack_public_path__ + "img/header.8f21d518.png";